import React, { useContext, useRef } from 'react';
import StatsButton from './StatsButton';
import { Slider } from '../../../../index';
import { SwiperSlide } from 'swiper/react';
import { Tooltip } from './Tooltip';
import { formatStatValue, periods, StatsEnum } from '../helpers';
import { useAnalyticsContext } from '../AnalyticsProvider';
import { AppDataContext } from 'contexts/appData';

export const StatsSelector = (props) => {
  const ref = useRef(null);
  const { activeTab, setActiveTab, currentTotal, activePeriod, difference, product } = useAnalyticsContext();
  const { langs } = useContext(AppDataContext);
  const periodLabel = periods.find((item) => item.value === activePeriod).label;

  const isOnlineShopProduct = product?.shop_type_id === 1

  return (
    <div className="d-flex stats-selector-container">
      <Slider customSwiper swiperProps={{ cssMode: true, className: 'swiper-container w-100 overflow-y-auto', slidesPerView: isOnlineShopProduct ? 5 : 4 }} ref={ref}>
        <SwiperSlide style={{ minWidth: 'max-content', display: 'flex' }}>
          <StatsButton
            isActive={activeTab === StatsEnum.Displays}
            title={langs?.NM_Displays}
            tooltipAnchor={StatsEnum.Displays}
            value={formatStatValue(currentTotal?.displays || 0)}
            onClick={() => {
              window.gtag('event', 'change_tab_in_product_analytics', {
                productId: product?.product_id,
                tab: StatsEnum.Displays,
                previousTab: activeTab
              });

              setActiveTab(StatsEnum.Displays)
            }}
            periodLabel={langs[periodLabel]}
            difference={difference?.displays}
          />
        </SwiperSlide>
        <SwiperSlide style={{ minWidth: 'max-content' }}>
          <StatsButton
            isActive={activeTab === StatsEnum.Views}
            title={langs?.NM_AnalyticsViews}
            tooltipAnchor={StatsEnum.Views}
            value={formatStatValue(currentTotal?.views || 0)}
            onClick={() => {
              window.gtag('event', 'change_tab_in_product_analytics', {
                productId: product?.product_id,
                tab: StatsEnum.Views,
                previousTab: activeTab
              });

              setActiveTab(StatsEnum.Views)
            }}
            periodLabel={langs[periodLabel]}
            difference={difference?.views}
          />
        </SwiperSlide>
        <SwiperSlide style={{ minWidth: 'max-content' }}>
          <StatsButton
            isActive={activeTab === StatsEnum.PhoneViews}
            title={langs?.NM_Calls}
            tooltipAnchor={StatsEnum.PhoneViews}
            value={formatStatValue(currentTotal?.phone_views || 0)}
            onClick={() => {
              window.gtag('event', 'change_tab_in_product_analytics', {
                productId: product?.product_id,
                tab: StatsEnum.PhoneViews,
                previousTab: activeTab
              });

              setActiveTab(StatsEnum.PhoneViews)
            }}
            periodLabel={langs[periodLabel]}
            difference={difference?.phone_views}
          />
        </SwiperSlide>
        <SwiperSlide style={{ minWidth: 'max-content' }}>
          <StatsButton
            isActive={activeTab === StatsEnum.Favorites}
              title={langs?.NM_Favorites}
            tooltipAnchor={StatsEnum.Favorites}
            value={formatStatValue(currentTotal?.favorites || 0)}
            onClick={() => {
              window.gtag('event', 'change_tab_in_product_analytics', {
                productId: product?.product_id,
                tab: StatsEnum.Favorites,
                previousTab: activeTab
              });


              setActiveTab(StatsEnum.Favorites)
            }}
            periodLabel={langs[periodLabel]}
            difference={difference?.favorites}
          />
        </SwiperSlide>
        {isOnlineShopProduct && <SwiperSlide style={{ minWidth: 'max-content' }}>
          <StatsButton
            isActive={activeTab === StatsEnum.AddToCart}
            title={langs?.M_Cart}
            tooltipAnchor={StatsEnum.AddToCart}
            value={formatStatValue(currentTotal?.add_to_cart || 0)}
            onClick={() => {
              window.gtag('event', 'change_tab_in_product_analytics', {
                productId: product?.product_id,
                tab: StatsEnum.AddToCart,
                previousTab: activeTab
              });

              setActiveTab(StatsEnum.AddToCart)
            }}
            periodLabel={langs[periodLabel]}
            difference={difference?.add_to_cart}
          />
        </SwiperSlide>}
      </Slider>

      <Tooltip anchor={`.${StatsEnum.Displays}`} style={{ textAlign: 'center', maxWidth: '200px', padding: '8px', zIndex: 1 }} text={langs?.NM_DisplaysTooltip} />
      <Tooltip anchor={`.${StatsEnum.Views}`} style={{ textAlign: 'center', maxWidth: '200px', padding: '8px' }} text={langs?.NM_ViewsTooltip} />
      <Tooltip anchor={`.${StatsEnum.PhoneViews}`} style={{ textAlign: 'center', maxWidth: '200px', padding: '8px' }} text={langs?.NM_CallsTooltip} />
      <Tooltip anchor={`.${StatsEnum.Favorites}`} style={{ textAlign: 'center', maxWidth: '200px', padding: '8px' }} text={langs?.NM_FavoritesTooltip} />

      {isOnlineShopProduct && <Tooltip anchor={`.${StatsEnum.AddToCart}`} style={{ textAlign: 'center', maxWidth: '200px', padding: '8px' }} text={langs?.NM_CartTooltip} />}
    </div>
  );
};
